import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTopItem = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0); // Scroll to the top of the page
    }, [pathname]); // Trigger whenever the route changes

    return null; // No visual output
};

export default ScrollToTopItem;